export enum TemplateApiEndpoints {
  GET_SITE = '/sites/:siteId',
  GET_SUBJECT_LINES = '/sites/:siteId/subject_lines',
  UPDATE_SUBJECT_LINE = '/sites/:siteId/subject_lines/:subjectLineId',
  GET_TEMPLATE = '/sites/:siteId/templates/new/:templateId/:language',
  GET_TEMPLATE_VERSION = '/sites/:siteId/templates/new/:templateId/:language/?versionId=:versionId',
  GET_ONSITE_TEMPLATE_VERSION = '/sites/:siteId/onsite/templates/:templateId/:language/?versionId=:versionId',
  GET_ONSITE_TEMPLATE = '/sites/:siteId/onsite/templates/:templateId/:language',
  GET_UNSUBSCRIBE_TEMPLATE = '/sites/:siteId/templates/new/unsubscribes/:templateId/:language',
  GET_EMAIL_TRACKING_UNSUBSCRIBE_TEMPLATE = '/sites/:siteId/templates/new/email-tracking-unsubscribes/:templateId/:language',
  ADD_TEMPLATE_LANGUAGE = '/sites/:siteId/templates/new/:templateId/:language',
  ADD_ONSITE_TEMPLATE_LANGUAGE = '/sites/:siteId/onsite/templates/:templateId/:language',
  GET_TEMPLATES = '/sites/:siteId/templates/new',
  GET_ARCHIVED_TEMPLATES = '/sites/:siteId/templates/new/archived',
  GET_UNSUBSCRIBE_TEMPLATES = '/sites/:siteId/templates/new/unsubscribes',
  GET_GLOBAL_UNSUBSCRIBE_TEMPLATES = '/sites/:siteId/templates/new/unsubscribes',
  /** Same path as marketing unsubscribes: siteId selects global vs site list (global site id vs site id). */
  GET_EMAIL_TRACKING_UNSUBSCRIBE_TEMPLATES = '/sites/:siteId/templates/new/email-tracking-unsubscribes',
  GET_GLOBAL_EMAIL_TRACKING_UNSUBSCRIBE_TEMPLATES = '/sites/:siteId/templates/new/email-tracking-unsubscribes',
  GET_EMAIL_ACQUISITION_TEMPLATES = '/sites/:siteId/onsite/templates?templateType=emailAcquisition',
  GET_SEND_MY_BASKET_TEMPLATES = '/sites/:siteId/onsite/templates?templateType=sendMyBasket',
  GET_DISPLAY_ONLY_TEMPLATES = '/sites/:siteId/onsite/templates?templateType=displayOnly',
  GET_MPS_EMBED_TEMPLATES = '/sites/:siteId/onsite/templates?templateType=mpsEmbed',
  GET_MPS_POPUP_TEMPLATES = '/sites/:siteId/onsite/templates?templateType=mpsPopup',
  ADD_SUBJECT_LINE = '/sites/:siteId/subject_lines',
  OFFSITE_PREVIEW = '/templates/compile',
  ONSITE_PREVIEW = '/templates/onsite/compile',
  CONVERT = '/templates/convert',
  UPDATE_TEMPLATE = '/sites/:siteId/templates/new/:templateId',
  UPDATE_ONSITE_TEMPLATE = '/sites/:siteId/onsite/templates/:templateId',
  UPDATE_ONSITE_TEMPLATE_CONTAINER = '/sites/:siteId/onsite/templates/:templateId/container',
  UPDATE_TEMPLATE_CONTAINER = '/sites/:siteId/templates/new/:templateId/container',
  CLONE_TEMPLATE = '/sites/:siteId/templates/new/:templateId/clone',
  CLONE_ONSITE_TEMPLATE = '/sites/:siteId/onsite/templates/:templateId/clone',
  MODIFY_LINK = '/templates/modify-template',
  GET_LINK_LOOKUPS = '/links/lookup/:siteId',
  GET_LINK_CONFIGS = '/links/config/:siteId',
  VALIDATE = '/templates/template-validation',
  GET_SNAPSHOT = '/sites/:siteId/snapshots/:snapshotId',
  GET_OFFSITE_SNAPSHOTS = '/sites/:siteId/snapshots',
  SAVE_TEMPLATE = '/sites/:siteId/templates/new',
  SAVE_ONSITE_TEMPLATE = '/sites/:siteId/onsite/templates',
  GET_TEMPLATE_HISTORY = '/sites/:siteId/templates/new/:templateId/:language/versions',
  RESTORE_TEMPLATE_VERSION = '/sites/:siteId/templates/new/:templateId/:language/restore',
  CHECK_TEMPLATE_USAGE = '/sites/:siteId/templates/new/:templateId/usage?campaignType=:campaignType',
  CHECK_ONSITE_TEMPLATE_USAGE = '/sites/:siteId/onsite/templates/:templateId/usage',
  ARCHIVE_TEMPLATE = '/sites/:siteId/templates/new/:templateId/archive?campaignType=:campaignType',
  ARCHIVE_ONSITE_TEMPLATE = '/sites/:siteId/onsite/templates/:templateId/archive',
  RESTORE_TEMPLATE = '/sites/:siteId/templates/new/:templateId/restore',
  RESTORE_ONSITE_TEMPLATE = '/sites/:siteId/onsite/templates/:templateId/restore',
  // Revist after backend implementation
  DELETE_TEMPLATE = '/sites/:siteId/templates/new/:templateId',
  DELETE_ONSITE_TEMPLATE = '/sites/:siteId/onsite/templates/:templateId',
}

export enum TemplateEnumsRoute {
  CHANNELS = '/templates/enums/channels',
  TEMPLATE_TYPES = '/templates/enums/template-types',
}
